import type {
  TGetAveragePrice,
  TGetMarketWatch,
  TGetOffers,
  TGetNews,
  TGetRecentStation,
  TGetRecommendedPrice,
} from '@/types/dashboard';
import type { TTransactionsSummary } from '@/types/transaction';

import { dashboardService } from '@/api/private';

export const getRecentStation: TGetRecentStation = (signal) =>
  dashboardService.get('recent-station', { signal });

export const getTransactionsSummary: TTransactionsSummary = ({ period, timezone }, signal) =>
  dashboardService.get('/transaction-summary', { params: { period, timezone }, signal });

export const getNews: TGetNews = (signal) =>
  dashboardService.get('/news', {
    params: {
      sort: 'datePublished,desc',
    },
    signal,
  });

export const getAveragePrice: TGetAveragePrice = ({ type, timezone, fuelType }, signal) =>
  dashboardService.get(`/avg-price/${type}`, { params: { timezone, fuelType }, signal });

export const getOffers: TGetOffers = (signal) => dashboardService.get('/offers', { signal });

export const getRecommendedPrice: TGetRecommendedPrice = (params, signal) =>
  dashboardService.get('/recommended-price', { params, signal });

export const getMarketWatch: TGetMarketWatch = (period, signal) =>
  dashboardService.get('/market-watch', { params: { period }, signal });
